// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-default[data-v-e59e409c]{background-color:#f5f7fd;width:100%}.backtop-layout[data-v-e59e409c]{width:60px;height:60px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
